var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('GameMenu',{on:{"menu":_vm.menuClick},model:{value:(_vm.menuValue),callback:function ($$v) {_vm.menuValue=$$v},expression:"menuValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }